import { Link } from "react-router-dom";

interface AlertBannerProps {
  urgentCount: number;
  warningCount: number;
}

const AlertBanner = ({ urgentCount, warningCount }: AlertBannerProps) => {
  if (urgentCount === 0 && warningCount === 0) return null;

  return (
    <div
      className="rounded-lg px-4 py-3 mb-5 flex items-center justify-between gap-4"
      style={{
        background: "linear-gradient(90deg, #FEF2F2 0%, #FFF7ED 100%)",
        border: "1px solid #FECACA",
      }}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-red-500 shrink-0">
          <i className="ri-alarm-warning-line text-white text-sm" />
        </div>
        <div>
          <p className="text-sm font-semibold text-red-800">즉시 확인이 필요한 이벤트가 있습니다</p>
          <p className="text-xs text-red-600 mt-0.5">
            미처리 긴급 이벤트 {urgentCount}건 · 오늘 무응답 {warningCount}건
          </p>
        </div>
      </div>
      <Link
        to="/admin/emergency"
        className="shrink-0 px-3 py-1.5 text-xs font-semibold text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
      >
        확인하기
      </Link>
    </div>
  );
};

export default AlertBanner;
